import React from "react";
import PropTypes from "prop-types";
import { Modal, Button, Form, Input, Select } from "antd";

const { TextArea } = Input;
const { Option } = Select;

const SubmitReportModal = ({ visible, onCancel, onFinish, isSubmitting, form, pendingReports }) => (
  <Modal
    title="Submit Progress Report"
    open={visible}
    onCancel={onCancel}
    centered
    footer={[
      <Button key="back" onClick={onCancel}>
        Cancel
      </Button>,
      <Button
        key="submit"
        type="primary"
        onClick={() => form.submit()}
        loading={isSubmitting}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Submitting..." : "Submit"}
      </Button>,
    ]}
  >
    <Form form={form} onFinish={onFinish} layout="vertical">
      <Form.Item
        name="taskId"
        label="Select Pending Task"
        rules={[{ required: true, message: "Please select a task!" }]}
      >
        <Select placeholder="Select a task">
          {pendingReports.map((task) => (
            <Option key={task.taskId} value={task.taskId}>
              {task.title}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item
        name="reportText"
        label="Enter Report"
        rules={[{ required: true, message: "Please enter your report!" }]}
      >
        <TextArea rows={4} placeholder="Enter your progress report..." />
      </Form.Item>
    </Form>
  </Modal>
);

SubmitReportModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  form: PropTypes.object.isRequired,
  pendingReports: PropTypes.arrayOf(
    PropTypes.shape({
      taskId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SubmitReportModal;
